// Marks "the user just tapped a tab in the nav" (KAN-1019). The shell reads the
// mark once, in the tab-change layout effect, to tell a nav tap (restore the
// tab's scroll) from any other content change (deep link, redirect → top).
// The mark is not tied to a tab name: worker/supervisor's one "Jobs" nav item
// lands on several content keys (route, history…), and the shell's own
// same-URL check is what makes a restore safe. One mark at a time, consumed
// once, never older than the window below.
const MARK_WINDOW_MS = 1500;

let markedAt = null;

export function markNavTabSwitch() {
  markedAt = performance.now();
}

/** True only for a fresh mark. ALWAYS clears the mark. */
export function consumeNavTabSwitch() {
  const at = markedAt;
  markedAt = null;
  return at != null && performance.now() - at < MARK_WINDOW_MS;
}

export function resetNavTabSwitchMarkForTests() {
  markedAt = null;
}
